import { FC, useMemo } from 'react';

import { RoundWinnerOutcomes } from 'shared/constants/shared-enums';
import { useRoomStore } from 'shared/store/roomStore';
import { getMoveIcon } from 'shared/utils/getMoveIcon';
import { getMoveIconText } from 'shared/utils/getMoveIconText';

interface IMobileHistoryMoveProps {
  round: {
    moveA: number;
    moveB: number;
    winner: RoundWinnerOutcomes;
  };
}

export const MobileHistoryMove: FC<IMobileHistoryMoveProps> = ({ round }) => {
  const { amIPlayerA } = useRoomStore();

  const topIcon = useMemo(
    () => getMoveIcon(amIPlayerA ? round.moveB : round.moveA, 'sm:w-6 w-4 scale-x-[-1] sm:w-8'),
    [round, amIPlayerA],
  );

  const bottomIcon = useMemo(
    () => getMoveIcon(amIPlayerA ? round.moveA : round.moveB, 'w-6 sm:w-12'),
    [round, amIPlayerA],
  );

  if (round.winner === RoundWinnerOutcomes.None) return null;
  return (
    <div
      className={` ${
        round.winner === RoundWinnerOutcomes.Draw
          ? 'bg-[#1D213E]'
          : (round.winner === RoundWinnerOutcomes.PlayerB && amIPlayerA) ||
              (round.winner === RoundWinnerOutcomes.PlayerA && !amIPlayerA)
            ? 'bg-[#89611c]'
            : 'bg-[#521732]'
      } relative flex h-14 w-10 shrink-0 flex-col items-center justify-between gap-px rounded-xl pt-px sm:h-[108px] sm:w-20 sm:pt-2`}
    >
      {topIcon}
      <div
        className={` ${
          round.winner === RoundWinnerOutcomes.Draw
            ? 'border-[#323E96] bg-[#1D213E]'
            : (round.winner === RoundWinnerOutcomes.PlayerA && amIPlayerA) ||
                (round.winner === RoundWinnerOutcomes.PlayerB && !amIPlayerA)
              ? 'border-[#ffc000] bg-[#89611c]'
              : 'border-[#E81C34] bg-[#521732]'
        } relative flex shrink-0 flex-col items-center justify-center gap-0.5 self-stretch rounded-[12px] border border-solid pb-1 pl-[9px] pr-[9px] pt-1`}
      >
        {bottomIcon}
        <div className="text-left text-[8px] font-semibold leading-[8px] text-white sm:text-md">
          {getMoveIconText(amIPlayerA ? round.moveA : round.moveB)}
        </div>
      </div>
    </div>
  );
};
